import { z } from 'zod';
import { RequiredErrorMessage } from './zodHelpers';
import { isEmailValid } from 'utils/email';

export const EmailSchema = z
  .string(RequiredErrorMessage)
  .min(1, RequiredErrorMessage)
  .refine(isEmailValid, { message: 'Invalid email address' });

export const PasswordSchema = z.string(RequiredErrorMessage).min(8, 'Password must be at least 8 characters long');
